import { Stack, Tab, Tabs, Typography } from '@mui/material';
import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate
} from '@tanstack/react-router';

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate({ from: Route.fullPath });

  const onTransactionsTab = () => navigate({ to: '/participant-transactions' });
  const onExportsTab = () =>
    navigate({ to: '/participant-transactions/exports' });

  return (
    <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
      <Typography variant='h5'>Transactions</Typography>

      <Tabs
        value={
          location.pathname.startsWith('/participant-transactions/exports')
            ? 'exports'
            : 'transactions'
        }>
        <Tab
          data-testid='transactionsTab'
          label='Transactions'
          onClick={onTransactionsTab}
          value='transactions'
        />
        <Tab
          data-testid='transactionExportsTab'
          label='Exports'
          onClick={onExportsTab}
          value='exports'
        />
      </Tabs>

      <Outlet />
    </Stack>
  );
};

export const Route = createFileRoute('/participant-transactions')({
  component: Layout
});
